<template>
  <v-inventory-create
    v-if="access.create_production"
    name="production"
    no-additional-cost
    ref="production"
    top_title="create_production"
  >
    <v-layout row>
      <v-flex class="px-3" md6>
        <v-autocomplete
          :label="$t('store')"
          v-bind:items="services"
          item-text="name"
          v-model="params.service"
          item-value="_id"
          ref="service"
          :rules="[fieldRules.required]"
        />
      </v-flex>
      <v-flex class="px-3" md6>
        <v-autocomplete
          :label="$t('employee')"
          v-bind:items="employees"
          item-text="name"
          v-model="params.employee"
          item-value="_id"
          ref="employee"
          :rules="[fieldRules.required]"
        />
      </v-flex>
    </v-layout>
    <v-radio-group row v-model="params.type">
      <v-radio :label="$t('production')" value="production" />
      <v-radio :label="$t('disassembly')" value="disassembly" />
    </v-radio-group>
    <template #items>
      <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        :items-per-page="200000"
        hide-default-footer
        disable-sort
        :no-data-text="$t('you_have_not_selected_items_yet')"
      >
        <template #[`item.name`]="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template #[`item.cost`]="{ item }">
          {{
            item.cost
              ? item.cost_currency == "usd"
                ? item.cost.toLocaleString() + " $"
                : Math.round(item.cost).toLocaleString()
              : item.cost
          }}
        </template>
        <template #[`item.quality`]="{ item }">
          <v-text-field
            v-model="item.quantity"
            reverse
            type="number"
            :ref="'quality' + item._id"
            :rules="[fieldRules.require]"
            @focus="$event.target.select()"
          />
        </template>
        <template #[`item.remove`]="{ item }">
          <v-btn icon v-on:click="remove_item(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-divider />
      <v-card-text>
        <v-search-items
          v-bind:label="$t('add_item')"
          v-bind:items="items_list"
          v-bind:selectedAct="add_item"
          v-bind:rules="items && items.length == 0 ? [fieldRules.required] : []"
          v-bind:searchItems="getItems"
        ></v-search-items>
      </v-card-text>
    </template>
    <template #action>
      <v-btn v-on:click="cancel" text>{{ $t("cancel") }}</v-btn>
      <v-btn
        color="success"
        :loading="loading_production"
        text
        v-on:click="save"
        :disabled="saveDisabled"
        >{{ $t(target) }}</v-btn
      >
    </template>
    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text"
          >This item has already been added</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-inventory-create>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
export default {
  name: "InventoryProductionsCreate",
  mixins: [Services],
  data: () => ({
    // headers: [
    //   { text: "Item", value: "name" },
    //   { text: "Cost", value: "cost", align: "right" },
    //   { text: "Quantity", value: "quality", align: "right", width: 100 },
    //   { text: null, value: "remove", align: "right", width: 80 },
    // ],
    items: [],
    items_list: [],
    employees: [],
    item: null,
    params: {
      service: null,
      type: "production",
    },
    exist_dialog: false,
    search_text: "123",
    loading_inv_items: false,
    loading_production: false,
  }),
  computed: {
    target() {
      return this.$route.params["target"];
    },
    form() {
      const fObj = {
        service: this.params.service,
        employee: this.params.employee,
      };
      for (const index in this.items) {
        fObj["quality" + this.items[index]._id] = this.items[index].quantity;
      }
      return fObj;
    },
    saveDisabled() {
      let formHasErrors = false || this.items.length == 0;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    headers() {
      let headers = [{ text: this.$t("item"), value: "name" },{ text: this.$t("cost"), value: "cost", align: "right" }];
      // if (this.user_access && this.user_access.inv_productions_cost) {
      //   headers.push({ text: this.$t("cost"), value: "cost", align: "right" });
      // }
      
      headers.push({
        text: this.$t("quantity"),
        value: "quality",
        align: "right",
        width: 100,
      });
      headers.push({ text: null, value: "remove", align: "center", width: 50 });
      return headers;
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    "params.service"() {
      this.update();
    },
  },
  methods: {
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push(this.$copy(item));
      }
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    cancel() {
      if (this.target == "create") {
        this.$router.push({ path: "/inventory/productions" });
      } else {
        this.$router.push({
          path: "/inventory/productions/view",
          query: this.$route.query,
        });
      }
    },
    async getItems(search) {
      if (typeof search != typeof "invan") {
        search = "";
      }
      if (this.search_text == search) {
        return;
      }
      this.search_text = search;
      this.loading_inv_items = true;
      const items = this.$communicator.then(
        this,
        await this.$communicator("production_items", {
          arguments: [50, 1],
          params: {
            search: search,
          },
        })
      );

      if (items) {
        this.items_list = [];

        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          this.items_list.push({
            ...items[index],
            search_text: search_text,
            product_id: items[index]._id,
            product_name: items[index].name,
            quantity: null,
          });
        }
      }
      this.loading_inv_items = false;
    },
    async update() {
      this.getItems();
      const employees = this.$communicator.then(
        this,
        await this.$communicator("get_employees_list", {
          params: { service: this.params.service },
        })
      );
      if (employees) {
        this.employees = employees;
      }
    },
    async save() {
      this.loading_production = true;
      var params = this.$copy(
        Object.assign(
          this.$copy(this.params),
          this.$refs["production"].options()
        )
      );
      var items = [];
      for (const index in this.items) {
        items.push({
          product_id: this.items[index]._id,
          quality: this.items[index].quantity,
        });
      }
      params.items = items;
      const response = this.$communicator.then(
        this,
        await this.$communicator("create_production", {
          params,
        })
      );
      if (response) {
        this.$router.push({
          path: "/inventory/productions/view",
          query: {
            id: response._id,
          },
        });
      }
      this.loading_production = false;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
